export const APP_STORE_URL = "https://apps.apple.com/us/app/diy-fly-fishing-v3/id1556251731";
export const GOOGLE_PLAY_URL = "https://play.google.com/store/apps/details?id=hr.apps.n185022";
